export default "__VITE_ASSET__CZ$CxthX__"